<header class="inputHeading">{{title}}</header>
<div *ngIf="isInputField && isReactive">
  <div [formGroup]="parentForm">
    <div class="inputTitle">
      <input autofocus [placeholder]="placeholder" maxlength="{{maxLength}}" [formControlName]="formFieldName" matInput required >
    </div>
  </div>
</div>

<div *ngIf="!isReactive && !isReadOnly">
    <div class="inputTitle">
      <input matInput autofocus [disabled]="isDisabled" [readonly]="isReadOnly" [required]="isRequired" [attr.maxlength]="maxLength"
            [placeholder]="placeholder" [value]="value" (blur)="blurEvent($event)" (focus)="focusEvent($event)" (keyup)="changeEvent($event)">
    </div>
</div>

<div *ngIf="!isReactive && isReadOnly">
  <header class="inputHeading">{{value}}</header>
</div>